<template lang="html">
  <v-dialog
    scrollable
    :value="true"
    max-width="800"
    persistent
    hide-overlay
    content-class="fill-height"
  >
    <v-card :class="{large: !appSmall}">
      <v-card-title
        class="headline grey lighten-2 pt-1"
        primary-title
      >
        <v-text-field
          v-model="filterDetails"
          placeholder="Details"
          hide-details
        />
      </v-card-title>

      <v-card-text class="pb-0 pt-4" style="flex: 100">
        <v-container
          class="text-center"
          fluid
          align-center
          justify-center
          v-if="loading"
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          />
        </v-container>
        <table
          v-else-if="items && items.length"
          class="table table-striped"
        >
          <tbody>
            <template v-for="item in items">
              <tr :key="item.key" v-if="item.key === 'calculated_data'">
                <td>Non Target Cost</td>
                <td>{{item.value && item.value.non_target_cost}}</td>
              </tr>
              <tr :key="item.key" v-else>
                <td>{{item.label}}</td>
                <td>{{item.text}}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <div v-else>No data found</div>
      </v-card-text>

      <v-divider></v-divider>

      <v-alert :value="true" type="error" style="width:100%" v-if="error">{{error}}</v-alert>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="$emit('close')"
          text
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
.large {
  .layout {
    .flex:first-child {
      padding-right: 8px;
    }
    .flex:last-child {
      padding-left: 8px;
    }
  }
}
</style>

<script>
import axios from 'axios'
import TestTypes from '@/lib/TestTypes'
import capitalize from 'lodash/capitalize'
import round from 'lodash/round'
import moment from 'moment-timezone'

export default {
  components: {
  },
  props: {
    recordId: {
      type: [String, Number]
    },
    machineId: {
      type: [String, Number]
    }
  },
  data () {
    return {
      loading: true,
      error: null,
      data: {},
      filterDetails: ''
    }
  },
  computed: {
    items () {
      let items = Object.keys(this.data)
      items = items.map((key) => {
        return {
          key,
          value: this.data[key],
          label: this.cleanKey(key),
          text: this.cleanValue(key, this.data[key])
        }
      })
      if (this.filterDetails) {
        items = items.filter(item =>
          (item.label && (item.label + '').includes(this.filterDetails)) ||
          item.label + '' === this.filterDetails + '' ||
          (item.text && (item.text + '').includes(this.filterDetails)) ||
          item.text + '' === this.filterDetails + ''
        )
      }
      return items
    }
  },
  methods: {
    fieldForKey (key) {
      let field = null
      TestTypes.forEach((testtype) => {
        if (field) {
          return
        }
        if (testtype.fields) {
          let _field = testtype.fields.find((field) => field.key === key)
          if (_field) {
            field = {
              ..._field,
              name: (_field.shared ? '' : (testtype.name + ' ')) + _field.name
            }
          }
        }
      })
      return field
    },
    cleanKey (key) {
      let field = this.fieldForKey(key)
      if (!field) {
        return capitalize(key.replace(/_/g, ' '))
      }
      return field.name
    },
    cleanValue (key, value) {
      let field = this.fieldForKey(key)
      if (!field) {
        return value
      }
      switch (field.type) {
        case 'timestamp':
          return moment(value).utc().format(field.format || 'MMMM Do YYYY, h:mm:ss a')
        case 'boolean':
          return value ? 'YES' : 'NO'
        case 'currency':
          return '$' + round(value, 2)
        case 'number':
          return round(value, field.precision || 1)
      }

      return value
    },
    async load () {
      if (this.recordId && this.machineId) {
        this.loading = true
        try {
          let response = await axios({
            method: 'GET',
            url: `/rest/machine/${this.machineId}/data/${this.recordId}`
          })

          this.data = response.data
          this.loading = false
        } catch (e) {
          this.loading = false
          throw e
        }
      }
    }
  },
  async created () {
    await this.load()
  }
}
</script>
